import React from 'react';
import { Modal, Input, Form, Select, Icon,DatePicker,Tabs} from 'antd';
import moment from "moment";
import { FORMAT_NUMBER, FORMAT_3DECIMALS, } from "../../../../common/types/regularExpresionType";
import Resumen from './Resumen';
import CierreSoles from './CierreSoles';
import CierreDolares from './CierreDolares';

import dialog from '../../../../common/utility/dialog';

import Footer from './Footer';
import FooterResumen from './FooterResumen';

const { Option } = Select;
const InputGroup = Input.Group;
const { Search } = Input;
const { TabPane } = Tabs;

class CierreModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === "" || isNaN(parseFloat(value).toFixed(3)))
          this.props.form.setFieldsValue({ [property]: "0.000" });
        else
          this.props.form.setFieldsValue({
            [property]: parseFloat(value).toFixed(3),
          });
      };

      handleCalculateDetail = (row, property, value, numberDecimals) => {
  
        /*********** Actualizar Detalle de Productos ********/
        var detalleProductos = this.props.form.getFieldValue("detalleSoles");

        var detalleProductosFilter = [];

        detalleProductos.forEach(element => {

            if (element.id === row.id) {
                detalleProductosFilter.push({
                id_CajaApertura :this.props.formValues.id,
                abreviatura: element.abreviatura,
                cantidad: parseInt(value),
                formato: element.formato,
                id: element.id,
                id_Moneda: element.id_Moneda,
                monto: element.monto,
                total: element.monto*value
            });

            }else{

                detalleProductosFilter.push({
                    id_CajaApertura :this.props.formValues.id,
                    abreviatura: element.abreviatura,
                    cantidad: parseInt(element.cantidad),
                    formato: element.formato,
                    id: element.id,
                    id_Moneda: element.id_Moneda,
                    monto: element.monto,
                    total: element.total
                });
            }


        });

        this.props.form.setFieldsValue({
            detalleSoles:detalleProductosFilter

        });


        this.props.formValues.listaEfectivoSoles=detalleProductosFilter;


      };

      handleCalculateDolar = (row, property, value, numberDecimals) => {
  
        /*********** Actualizar Detalle de Productos ********/
        var detalleProductos = this.props.form.getFieldValue("detalleDolares");

        var detalleProductosFilter = [];

        detalleProductos.forEach(element => {

            if (element.id === row.id) {
                detalleProductosFilter.push({
                id_CajaApertura :this.props.formValues.id,
                abreviatura: element.abreviatura,
                cantidad: parseInt(value),
                formato: element.formato,
                id: element.id,
                id_Moneda: element.id_Moneda,
                monto: element.monto,
                total: element.monto*value
            });

            }else{

                detalleProductosFilter.push({
                    id_CajaApertura :this.props.formValues.id,
                    abreviatura: element.abreviatura,
                    cantidad: parseInt(element.cantidad),
                    formato: element.formato,
                    id: element.id,
                    id_Moneda: element.id_Moneda,
                    monto: element.monto,
                    total: element.total
                });
            }


        });

        this.props.form.setFieldsValue({
            detalleDolares:detalleProductosFilter

        });


        this.props.formValues.listaEfectivoDolares=detalleProductosFilter;


      };


    handleCancel = () => {
        this.props.onClose();
        //this.props.form.resetFields();
    }
    
    handleEfectivos = () => {

        debugger
        var detalleSoles = this.props.form.getFieldValue("detalleSoles");
        var detalleDolares = this.props.form.getFieldValue("detalleDolares");
        var result =detalleSoles.concat(detalleDolares);

        const validFormLogic = this.validateFormLogic(detalleSoles, detalleDolares, result);
        if (!validFormLogic) {
          return;
        }

        this.props.onSave(result,this.props.form);
    }


          
  validateFormLogic = (detalleSoles, detalleDolares) => {

    var result=this.props.formValues.listaResumen;
     /*   if (result.length == 0) {

          dialog.error('No se puede cerrar la caja por que no realizo ninguna venta');

          return false;
      }

     var totalDolares =props.formValues.listaEfectivoDolares.reduce((a, b) => a + (b["total"] || 0), 0)
      var totalSoles =props.formValues.listaEfectivoSoles.reduce((a, b) => a + (b["total"] || 0), 0)

   */
  
    

    return true;
  };



    render() {
        
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        getFieldDecorator("detalleSoles", {
            initialValue: this.props.formValues.listaEfectivoSoles,
          });
      
          
        getFieldDecorator("detalleDolares", {
            initialValue: this.props.formValues.listaEfectivoDolares,
          });
      

        return (
            <Modal
                title={"Ver Apertura de Caja"}
                visible={this.props.visible}
                cancelText={"Cerrar"}
                okText={"Cerrar Caja"}
                onCancel={this.handleCancel}
                onOk={this.handleEfectivos} 
                style={{ top: 30 }}
                width="1000px"
            >
                <Form>


                    <div className="row">

                        <div className="col-md-6">
                            <Form.Item label="Serie / Documento">
                        

                                <InputGroup compact>
                                    <Form.Item style={{ width: "40%" }}>
                                        {getFieldDecorator("serie", {
                                            initialValue: this.props.formValues.serie,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <Input
                                            readOnly
                                            className="text-right second-input"
                                            placeholder="Serie"
                                            autoComplete="off"
                                        
                                        />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "60%" }}>
                                        {getFieldDecorator("correlativo", {
                                            initialValue: this.props.formValues.correlativo,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Correlativo",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                             
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>


                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "65%" }}>
                                        {getFieldDecorator("FechaTipoCambio", {
                                            initialValue: moment(
                                                this.props.formValues.FechaTipoCambio,
                                                "DD/MM/YYYY"
                                            ),
                                            rules: [
                                                {
                                                    type: "object",
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={
                                                    <Icon
                                                        type="filter"
                                                        style={{ color: "rgba(0,0,0,.25)" }}
                                                    />
                                                }
                                                disabled={true}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) =>
                                                    this.props.onChange(
                                                        "fechaStr",
                                                        value,
                                                        this.props.form
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "35%" }}>
                                        {getFieldDecorator("TipoCambio", {
                                            initialValue: parseFloat(
                                                this.props.formValues.TipoCambio
                                            ).toFixed(3),
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_3DECIMALS),
                                                    message: "Formato decimal incorrecto (0.000)",
                                                },
                                            ],
                                        })(
                                            <Input
                                            readOnly
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) =>
                                                    this.handleCompleteDecimals(
                                                        "TipoCambio",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>

                    </div>
                    


                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator("idEstablecimiento", {
                                    initialValue: this.props.formValues.idEstablecimiento
                                        ? { key: this.props.formValues.idEstablecimiento }
                                        : undefined,
                                    rules: [
                                        {
                                            required: false,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.listaEstablecimiento.map((item) => (
                                            <Option key={item.id} value={item.id} disabled>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Caja">
                                {getFieldDecorator("idCaja", {
                                    initialValue: this.props.formValues.idCaja
                                        ? { key: this.props.formValues.idCaja }
                                        : undefined,
                                    rules: [
                                        {
                                            required: false,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                         
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Caja"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.listaCaja.map((item) => (
                                            <Option key={item.id} value={item.id} disabled>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-6">
                        <Form.Item label="Vendedor">
                                {getFieldDecorator('responsable', {
                                    initialValue: this.props.formValues.responsable,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Search
                                    readOnly
                                    placeholder="Búsqueda por Documento"
                                    autoComplete="off"
                                    maxLength={20}
                                    //loading={this.props.formValues.searchLoading}
                                    //onSearch={this.handleFilter}
                                />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                        <Form.Item label="Usuario">
                                {getFieldDecorator('usuario', {
                                    initialValue: this.props.formValues.usuario,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                    readOnly
                                        placeholder="Ingresar usuario"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>

                            <Form.Item label="idEmpleado" hidden>
                                {getFieldDecorator('idResponsable', {
                                    initialValue: this.props.formValues.idResponsable,
                                  
                                })(
                                    <Input
                                       hidden
                                        placeholder="Ingresar usuario"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                        <Form.Item label="Saldo Inicial Soles">
                                {getFieldDecorator('saldoSoles', {
                                    initialValue: this.props.formValues.saldoSoles,
                                    rules: [{
                                        required: false,
                                        pattern: new RegExp(FORMAT_NUMBER),
                                        message: "Formato decimal incorrecto (0.00)",
                                    }]
                                })(
                                    <Input
                                    readOnly
                                        placeholder="Ingresar Saldo Soles"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                        <Form.Item label="Saldo Inicial Dolares">
                                {getFieldDecorator('saldoDolares', {
                                    initialValue: this.props.formValues.saldoDolares,
                                    rules: [{
                                        required: false,
                                        pattern: new RegExp(FORMAT_NUMBER),
                                        message: "Formato decimal incorrecto (0.00)",
                                    }]
                                })(
                                    <Input
                                    readOnly
                                        placeholder="Ingresar Saldo Dolares"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
           
                    <div className="row">
                        <div className="col-md-12 form-group">
                             <Tabs>
                                <TabPane tab="Resumen" key="1">
                                    <Resumen
                                        dataSource={this.props.formValues.listaResumen}                                         
                                    />
                                </TabPane>

                        </Tabs>  
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <FooterResumen
                                MontoGlobal={this.props.formValues.listaResumen}
                            />


                        </div>


                    </div>

                    
                    <div className="row">
                        <div className="col-md-12 form-group">
                             <Tabs>
                                <TabPane tab="Cierre de arqueo - EFECTIVO" key="1">
                                    <div className="row">
                                    <div className="col-md-6 form-group">
                                    <CierreSoles
                                        dataSource={this.props.formValues.listaEfectivoSoles} 
                                        onGetFieldDecorator={getFieldDecorator}   
                                        onCalculateDetail={this.handleCalculateDetail}
                                     
                                    />
                                    </div>
                                    <div className="col-md-6 form-group">
                                    <CierreDolares
                                        dataSource={this.props.formValues.listaEfectivoDolares}
                                        onGetFieldDecorator={getFieldDecorator} 
                                        handleCalculateDolar={this.handleCalculateDolar}
                                       
                                    />
                                    </div>
                                    </div>
                          
                             
                                </TabPane>

                        </Tabs>  
                        </div>
                     
                    </div>

                    <Footer
                        formValues={this.props.formValues}
                    />
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(CierreModal)